'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('application', {
      url: '/application/:id',
      template: '<application></application>'
    });
}



// WEBPACK FOOTER //
// ./client/app/application/application.routes.js